module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "builder__font-option"
  }, [_c('div', {
    staticClass: "builder__font-option-name"
  }, [_vm._v("\n    " + _vm._s(_vm.option.display_title ? _vm.option.display_title : _vm.option.title) + ":\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "builder__font-option-choices"
  }, [_vm._l((_vm.option.choices), function(choice) {
    return _c('div', {
      staticClass: "builder__font-option-choice"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selection),
        expression: "selection"
      }],
      staticClass: "builder__font-option-choice-input",
      attrs: {
        "type": "radio",
        "id": _vm.domId(choice.id)
      },
      domProps: {
        "value": choice.id,
        "checked": _vm._q(_vm.selection, choice.id)
      },
      on: {
        "change": function($event) {
          _vm.selection = choice.id
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "builder__font-option-choice-label",
      attrs: {
        "for": _vm.domId(choice.id)
      }
    }, [_c('span', {
      staticClass: "builder__font-option-choice-label-fake-input"
    }), _vm._v(" "), (choice.font_label_image_fID) ? [_c('span', {
      staticClass: "builder__font-option-choice-label-text builder__font-option-choice-label-text--hidden"
    }, [_vm._v(_vm._s(choice.title))]), _vm._v(" "), _c('img', {
      staticClass: "builder__font-option-choice-label-sample",
      attrs: {
        "src": choice.font_label_image_src,
        "alt": ""
      }
    })] : [_c('span', {
      staticClass: "builder__font-option-choice-label-text"
    }, [_vm._v(_vm._s(choice.title))])]], 2)])
  }), _vm._v(" "), (!_vm.option.is_required) ? _c('div', {
    staticClass: "builder__font-option-choice"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selection),
      expression: "selection"
    }],
    staticClass: "builder__font-option-choice-input",
    attrs: {
      "type": "radio",
      "id": _vm.domId('none')
    },
    domProps: {
      "value": null,
      "checked": _vm._q(_vm.selection, null)
    },
    on: {
      "change": function($event) {
        _vm.selection = null
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "builder__font-option-choice-label",
    attrs: {
      "for": _vm.domId('none')
    }
  }, [_c('span', {
    staticClass: "builder__font-option-choice-label-fake-input"
  }), _vm._v(" "), _c('span', {
    staticClass: "builder__font-option-choice-label-text"
  }, [_vm._v("None")])])]) : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08c54461"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/option-types/Font.vue
// module id = 364
// module chunks = 0